<template>
  <div class="page-container">
    <div class="card-title" v-show="showSearch">
      <el-form size="small" label-width="68px" :model="queryParams" ref="queryForm">
        <el-row :gutter="48">
          <el-col :md="6" :sm="24">
            <el-form-item label="公告标题">
              <el-input v-model="queryParams.title" class="search-item" placeholder="请输入公告标题" size="small" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="24">
            <el-form-item label="公告类型">
              <el-select v-model="queryParams.type" class="search-item" placeholder="请选择公告类型" clearable>
                <el-option label="通知" :value="1"></el-option>
                <el-option label="公告" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="24">
            <!-- 创建时间 -->
            <el-form-item label="创建时间" size="small">
              <el-date-picker
                v-model="queryParams.dataRange"
                class="search-item"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <!-- 搜索按钮 -->
          <div class="search-content">
            <el-form-item class="search-button">
              <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
              <el-button icon="el-icon-refresh" size="mini" @click="handleReset">重置</el-button>
              <el-button type="text" :icon="advanced ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" class="advanced-button" @click="toggleAdvanced">
                {{ advanced ? '关闭' : '展开' }}
              </el-button>
            </el-form-item>
          </div>
        </el-row>
      </el-form>
    </div>

    <div class="card">
      <el-row :gutter="10" class="button-container">
        <el-col :span="1.5">
          <el-button type="primary" icon="el-icon-plus" @click="handleAdd" size="mini" plain>
            新增
          </el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button type="success" icon="el-icon-edit" size="mini" plain :disabled="single" @click="handleUpdate">编辑</el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button type="danger" icon="el-icon-delete" size="mini" plain :disabled="multiple" @click="handleDelete" :loading="buttonLoading">删除</el-button>
        </el-col>
        <right-toolbar :showSearch.sync="showSearch" :columns="columns" @getTableData="getTableData"></right-toolbar>
      </el-row>

      <el-table v-loading="loading" element-loading-text="正在加载表格数据" :data="tableData" @selection-change="handleSelectionChange" border>
        <template slot="empty">
          <el-empty :image-size="200"></el-empty>
        </template>
        <el-table-column type="selection" width="50" align="center" />
        <!-- 公告标题 -->
        <el-table-column prop="title" label="公告标题" align="center" v-if="columns[0].visible"></el-table-column>
        <!-- 公告类型 -->
        <el-table-column prop="type" label="公告类型" align="center" v-if="columns[1].visible">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.type === 1">通知</el-tag>
            <el-tag type="success" v-else-if="scope.row.type === 2">公告</el-tag>
          </template>
        </el-table-column>
        <!-- 公告状态 -->
        <el-table-column prop="status" label="公告状态" align="center" v-if="columns[2].visible">
          <template slot-scope="scope">
            <el-tag type="primary" v-if="scope.row.status">正常</el-tag>
            <el-tag type="danger" v-else>关闭</el-tag>
          </template>
        </el-table-column>
        <!-- 创建者 -->
        <el-table-column prop="createBy" label="创建者" align="center" v-if="columns[3].visible"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" v-if="columns[4].visible">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | dateFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作"  align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" icon="el-icon-edit" @click="handleUpdate(scope.row)">编辑</el-button>
            <el-button type="text" size="small" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页器 -->
      <pagination :background="false" :total="total" :page.sync="queryParams.currentPage" :limit.sync="queryParams.pageSize" @pagination="getTableData" />
    </div>

    <!-- 通知公告信息对话框 -->
    <el-dialog
      :title="noticeTitle"
      width="980px"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :visible="noticeVisible"
      :before-close="handleClose">
      <div class="notice-wrapper" v-loading="noticeLoading" element-loading-text="正在加载通知公告信息">
        <el-form ref="noticeForm" :model="formData" :rules="rules" label-width="80px" label-position="right">
          <el-row :gutter="20" class="form-row">
            <el-col :span="24">
              <!-- 公告标题 -->
              <el-form-item label="公告标题" prop="title">
                <el-input v-model="formData.title" placeholder="请输入公告标题" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 公告类型 -->
              <el-form-item label="公告类型" prop="type">
                <el-select v-model="formData.type" placeholder="请选择公告类型" clearable>
                  <el-option label="通知" :value="1"></el-option>
                  <el-option label="公告" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 公告状态 -->
              <el-form-item label="公告状态" prop="status">
                <el-radio-group v-model="formData.status">
                  <el-radio :label="true">正常</el-radio>
                  <el-radio :label="false">关闭</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!-- 公告内容 -->
              <el-form-item label="公告内容" prop="content">
                <vue-editor v-model="formData.content" :useCustomImageHandler="true"  @image-added="handleImageAdded" :customModules="customModulesForEditor" :editorOptions="editorSettings"></vue-editor>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!-- 备注 -->
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" v-model="formData.remark" placeholder="请输入备注" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button
          type="danger"
          :loading="buttonLoading"
          @click="handleClose()"
          size="small"
          icon="el-icon-error">
          取消
        </el-button>
        <el-button
          type="success"
          :loading="buttonLoading"
          @click="submitForm()"
          size="small"
          icon="el-icon-success">
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '../../../components/Pagination/index.vue'
import RightToolbar from '../../../components/RightToolbar/index.vue'
import { listNotices, saveNotice, getNoticeById, deleteNotice } from '../../../api/system/notice'
import { addImage } from '../../../api/webiste/file'
// 导入图片操作相关插件
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'

export default {
  name: 'Notice',

  components: { Pagination, RightToolbar },

  data () {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 是否展示搜索内容
      showSearch: true,
      // 数据总条数
      total: 0,
      // 通知公告对话框是否显示
      noticeVisible: false,
      // 数据表格等待框
      loading: false,
      // 查询参数
      queryParams: {
        // 页数
        currentPage: 1,
        // 页面大小
        pageSize: 10,
        // 公告标题
        title: undefined,
        // 公告类型
        type: undefined,
        // 时间范围
        dataRange: []
      },
      // 通知公告表单对象
      formData: {
        // 公告内容
        content: undefined,
        // 创建者
        createBy: undefined,
        // 备注
        remark: undefined,
        // 公告状态
        status: undefined,
        // 公告标题
        title: undefined,
        // 公告类型
        type: undefined,
        // 更新者
        updateBy: undefined
      },
      // 通知公告表单校验规则
      rules: {
        // 公告标题
        title: [{ required: true, message: '请输入公告标题', trigger: 'blur' }],
        // 公告类型
        type: [{ required: true, message: '请输入公告类型', trigger: 'blur' }]
      },
      // 通知公告对话框等待框
      noticeLoading: false,
      // 对话框按钮等待框
      buttonLoading: false,
      // 列信息
      columns: [
        // 公告内容
        { key: 0, label: '公告内容', visible: true },
        // 创建者
        { key: 1, label: '创建者', visible: true },
        // 备注
        { key: 2, label: '备注', visible: true },
        // 公告状态
        { key: 3, label: '公告状态', visible: true },
        // 公告标题
        { key: 4, label: '公告标题', visible: true },
        // 公告类型
        { key: 5, label: '公告类型', visible: true },
        // 更新者
        { key: 6, label: '更新者', visible: true },
        { key: 7, label: '创建时间', visible: true },
        { key: 8, label: '更新时间', visible: true }
      ],
      // 表格数据
      tableData: [],
      // 表头选中的数据
      ids: [],
      // 多数据禁用
      single: true,
      // 单数据禁用
      multiple: true,
      // 对话框标题
      noticeTitle: '',
      // 调整图片大小和位置
      customModulesForEditor: [
        { alias: 'imageDrop', module: ImageDrop },
        { alias: 'imageResize', module: ImageResize }
      ],
      // 设置编辑器图片可拖拽
      editorSettings: {
        modules: { imageDrop: true, imageResize: {} }
      }
    }
  },

  computed: {},

  watch: {},

  created () {},

  mounted () {
    // 查询表格数据
    this.getTableData()
  },

  methods: {
    // 获取表格数据
    getTableData () {
      // 开启加载框
      this.loading = true
      listNotices(this.queryParams).then((res) => {
        // 赋值数据参数
        this.tableData = res.list
        this.total = res.total
        // 关闭等待框
        this.loading = false
      }).catch(() => {
        // 确保加载框可以关闭
        this.loading = false
      })
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 点击查询按钮
    handleQuery () {
      this.queryParams.currentPage = 1
      this.getTableData()
    },
    // 点击重置按钮
    handleReset () {
      // 公告标题
      this.queryParams.title = undefined
      // 公告类型
      this.queryParams.type = undefined
      this.queryParams.dataRange = []
    },
    // 打开通知公告信息对话框
    handleOpen () {
      // 清除表单数据
      this.reset()
      this.noticeVisible = true
    },
    // 关闭通知公告对话框表单
    handleClose () {
      this.reset()
      this.noticeVisible = false
    },
    // 点击新增按钮
    handleAdd () {
      this.noticeTitle = '新增通知公告'
      this.handleOpen()
    },
    // 点击编辑按钮
    handleUpdate (row) {
      // 修改对话框标题
      this.noticeTitle = '更新通知公告'
      // 获取到传来的ID
      const noticeId = row.id || this.ids
      // 打开加载框
      this.noticeLoading = true
      // 根据通知公告ID获取对应的数据
      getNoticeById(noticeId).then((res) => {
        // 赋值当前的通知公告数据
        this.formData = res
        // 打开编辑通知公告对话框
        this.noticeVisible = true
        // 关闭加载框
        this.noticeLoading = false
      }).catch(() => {
        // 关闭加载框
        this.noticeLoading = false
      })
    },
    // 点击删除事件
    handleDelete (row) {
      const that = this
      let noticeIds = []
      if (row.id) {
        noticeIds.push(row.id)
      } else {
        noticeIds = this.ids
      }
      this.$confirm('是否确认删除选中的通知公告数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.buttonLoading = true
        that.loading = true
        deleteNotice(noticeIds).then((res) => {
          that.buttonLoading = false
          that.$message.success('删除成功')
          // 刷新数据
          that.getTableData()
        }).catch(() => {
          // 确保加载框会关闭
          that.buttonLoading = false
          that.loading = false
        })
      }).catch(() => {})
    },
    // 提交表单
    submitForm () {
      const that = this
      this.$refs.noticeForm.validate(valid => {
        // 校验未通过则直接返回
        if (!valid) return
        // 开启加载框
        that.buttonLoading = true
        that.noticeLoading = true
        // 提交表单
        saveNotice(that.formData).then((res) => {
          // 根据是否存在ID输出对应消息
          if (that.formData.id) {
            // 输出更新成功信息
            that.$message.success('通知公告信息更新成功')
          } else {
            // 输出添加成功消息
            that.$message.success('通知公告添加成功')
          }
          // 刷新表单数据并关闭对话框
          that.handleClose()
          // 刷新通知公告数据
          that.getTableData()
          // 关闭加载框
          that.buttonLoading = false
          that.noticeLoading = false
        }).catch(() => {
          // 关闭加载框
          that.buttonLoading = false
          that.noticeLoading = false
        })
      })
    },
    // 重置表单
    reset () {
      // 清除校验条件
      this.formData = {
        // 通知公告ID
        id: undefined,
        // 公告标题
        title: undefined,
        // 公告类型
        type: undefined,
        // 公告状态
        status: true
      }
      // 清除表单校验
      this.resetForm('noticeForm')
    },
    // 多选框
    handleSelectionChange (selection) {
      // 获取当前选中数组的ID
      this.ids = selection.map(item => item.id)
      // 表头的编辑是否可以点击
      this.single = selection.length !== 1
      // 表头的删除是否可以点击
      this.multiple = !selection.length
    },
    // 图片上传方法
    handleImageAdded (file, Editor, cursorLocation, resetUploader) {
      // 定义文件上传对象
      let formData = new FormData()
      formData.append('fileTypeId', '1656676089927303169')
      formData.append('file', file)

      addImage(formData).then((res) => {
        const url = res
        formData = undefined
        // 将图片插入到编辑器的文本中
        Editor.insertEmbed(cursorLocation, 'image', url)
        // 重置上传器状态
        resetUploader()
      }).catch(() => {
        this.$message.error('上传失败')
      })
    }
  }
}

</script>

<style lang="scss" scoped>
.notice-wrapper {
  padding: 10px 30px;
}
</style>
